<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          应用人脸识别和激光引导技术的五防安全辅助装置
        </div>
        <div class="txt">
          Five anti-security aids applying face recognition and laser guidance technology
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>“人脸识别和激光引导技术的五防安全辅助装置研制”的研究成果由国网上海市电力公司市北供电公司于2020年1月起在钱湾站内部
署应用。</p>
          <p>
       本产品主要解决了运检人员有时会误操作，影响变电站正常运行的问题。在研究成果应用过程中，基于激光引导的智能巡检机器人可通过模拟屏识别操作票，识别站内的正常/异常情况，代人辅助完成巡检工作，大大减少了人员误操作的可能性。并且配备了基于人脸识别的五防安全锁，在发生意外情况，如机器人无法正常工作时，工作人员可以通过人脸识别解锁，再进行人工操作，保障了变电站现场设备的正常运行，提高了变电站的工作效率，大大减少了电力误操作的出现。/异常状态，并在硬件采集平台的界面上显示报警信息。达到了在无人值守的情况下，实时监测变电站现场设备状况的作用，保障了变电站现场设备的正常运行，提升了变电站现场设备的运行效率。</p>
        </div> 
      </div>
      <div>
        <div class="title">产品图片</div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic73.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one" style="marginTop: 10px">
            <img src="../assets/pic74.png" alt="">
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 280px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one .one img {
  width: 1000px;
  height: 450px;
}
.img_one img {
  width: 430px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}


.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail10.vue